import { useMemo } from 'react';
import { DASHES } from '@fortress-technology-solutions/fortress-component-library/constants';
import { formatNaurPercentage } from '../ManageBuildings/BuildingsTable/utils';
import v1Messages from '../ManageBuildings/messages';
import messages from './messages';
import type { ParsedBuilding } from './types';

const textCell = (value: ?string) => ({ value: value || DASHES });

const dateCell = (value: ?string) =>
  value ? { variant: 'dateUTC', value } : { value: DASHES };

const useRows = ({
  buildings,
  canEdit,
  intl,
  openEdit,
}: {
  buildings: ParsedBuilding[],
  canEdit: boolean,
  intl: Object,
  openEdit: Function,
}) =>
  useMemo(
    () =>
      buildings.map((building) => ({
        id: building.id,
        name: { value: building.name },
        buildingAddress: { value: building.buildingAddress },
        // null or missing means the API did not send a count; 0 is a real count and must show as 0.
        unitsCount:
          building.unitsCount == null
            ? { value: DASHES }
            : { variant: 'number', value: building.unitsCount },
        XMLSiteName: textCell(building.XMLSiteName),
        placedInServiceDate: dateCell(building.placedInServiceDate),
        buildingIDNumber: textCell(building.buildingIDNumber),
        PHBuildingNumber: textCell(building.PHBuildingNumber),
        PHBuildingEntrance: textCell(building.PHBuildingEntrance),
        RDSiteId: textCell(building.RDSiteId),
        minimumSetAside: textCell(building.minimumSetAside),
        applicableFractionUnit: {
          value: formatNaurPercentage(building.applicableFractionUnit),
        },
        applicableFractionFloorSpace: {
          value: formatNaurPercentage(building.applicableFractionFloorSpace),
        },
        heraSpecial: { value: building.heraSpecialLabel },
        fundingType: textCell(building.fundingTypeLabel),
        certificateOfOccupancyDate: dateCell(
          building.certificateOfOccupancyDate,
        ),
        constructionType: textCell(building.constructionTypeLabel),
        actions: {
          variant: 'menu',
          name: 'actionsMenu',
          iconName: 'BoltIcon',
          color: 'primary',
          closeOnClick: true,
          options: [
            {
              value: 'edit',
              text: intl.formatMessage(v1Messages.edit),
              disabled: !canEdit,
              tooltip: canEdit
                ? null
                : intl.formatMessage(messages.noPermissionTooltip),
              onClick: () => openEdit({ modalType: 'edit', building }),
            },
          ],
        },
      })),
    [buildings, canEdit, intl, openEdit],
  );

export default useRows;
